<template>
  <div id="instrument-operation">
    <common-search :searchList="searchList" @onSearch="onSearch"></common-search>

    <common-table 
      :machineList="machineList" 
      :loading="loading" 
      @sort-change="sortChange"
      @data-change="getMessageByPage"
      storageName="checkedHeaders_borrow"
      title="广东省特种设备检测研究院惠州检测院设备借还表"
      type="operation"
      height="650"
      :tableHandler="tableHandler"
      ></common-table>

    <div style="text-align: right;margin-top:10px">
       <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  name: 'instrument-operation',
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  data() {
    return {
      loading: false,
      machineList: null,
      searchList: {
        newMachineNO: '',departmentId: '',userName: '',audit: '',name: ''
      },
      tableHandler: [
        'audit'
      ],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 20,
      uploading: '',
    }
  },
  async mounted(){
    if(this.$route.params && this.$route.params['auditType']){
      const auditType = this.$route.params['auditType']
      if(auditType === '借用'){
        this.searchList.audit = '借出审核中';
      }else if(auditType === '归还'){
        this.searchList.audit = '归还审核中';
      }
    }

    this.getMessageByPage();
  },
  watch: {
    // '$route.matched':{
    //   handler(newVal,oldVal){
    //     this.getMessageByPage();
    //   },
    //   immediate: true
    // }
  },
  methods: {
    async getMessageByPage(){
      this.loading = true;

      let borrowType = 'admin_current';
      if(this.searchList.audit === '借出审核中'){
        borrowType = 'admin_current_borrow'
      }else if(this.searchList.audit === '归还审核中'){
        borrowType = 'admin_current_return'
      }

      let options = this.$util.formatOptions(this.searchList);
      if(this.searchList.departmentId !== '' && this.searchList.departmentId !== 1)
        options['departmentId'] = this.searchList.departmentId;

      if(this.$util.isEmpty(this.order))
        this.order = "default";
      //console.log(options);
      let _machineList = await this.$equipmentdata.getMessageByPage('operation',this.currentPage,this.pageSize,JSON.stringify(options),this.order,borrowType);
      this.machineList = _machineList.result;
      this.total = _machineList.total
      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

    sortChange(val){
      this.order = val.order;
      this.getMessageByPage();
    },

    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    }
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-operation{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Audit.vue